<template>
	<div class="container">
		<p>筛选查询</p>
		<div class="container crumbs">
			<div class="handle-search">
				<e-search :data="formData" :field-list="fieldList" :list-type-info="listTypeInfo" :btnStyle="btnStyle"
					@handleReset="handleClear" @handleFilter="handleQuery"></e-search>
			</div>
		</div>
		<p>日志列表</p>
		<div class="container crumbs">
			<TableList :loading="loading" :table-data="tableData" :table-label="tableLabel" @handleButton="handleButton"
				@handleSortChange="handleSortChange" @handleSelectionChange="handleSelectionChange"></TableList>
			<div class="pagination">
				<el-pagination background layout="total, sizes, prev, pager, next, jumper" :current-page="page.pageNum"
					:page-sizes="[10, 20, 50, 100, 200]" :page-size="page.pageSize" :total="pageTotal"
					@current-change="handlePageChange" @size-change="handleSizeChange"></el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import ESearch from "../../components/common/e-search";
	import TableList from "../../components/common/e-table-list";
	import api from "../../api/logsystem/index";

	export default {
		//   name: "productCatalogExam",
		components: {
			ESearch,
			TableList
		},
		data() {
			return {
				loading: false,
				tableData: [],
				tableLabel: [{
						label: "序号",
						param: "",
						align: "center"
					},
					{
						label: "操作类型",
						param: "logType",
						align: "center",
						width: "200",
						render: (row) => {
							if (row.logType === "ADD") {
								return "新增人员";
							} else if (row.logType == "MODIFY") {
								return "修改人员";
							} else if (row.logType == "DELETE") {
								return "删除人员";
							}
						},
					},
					{
						label: "操作人",
						param: "operatorRealName",
						align: "center"
					},
					{
						label: "操作时间",
						param: "createTime",
						align: "center"
					},
					{
						label: "登录账号",
						param: "operatorMemberName",
						align: "center"
					},
					{
						label: "手机账号",
						param: "mobile",
						align: "center"
					},
					{
						label: "电子邮箱",
						param: "email",
						align: "center"
					},
					{
						label: "IP地址",
						param: "memberIp",
						align: "center"
					},
				],
				//   tableOption: {
				//     label: "操作",
				//     width: "300",
				//     fixed: "right",
				//     options: [
				//       { label: "查看详情", type: "primary", methods: "handleOrderDetail" },
				//       { label: "查看并确认", type: "primary", methods: "handleOrderConfirm" },
				//      ],
				//     flag: true,
				//   },
				fieldList: [{
						label: "操作类型",
						type: "select",
						value: "supplierCompanyName",
						list: "applicationStatus",
					},
					{
						label: "操作人",
						type: "input",
						value: "applicationStatus"
					},
					{
						label: "操作时间",
						type: "date",
						value: "startTime",
						dateType: "daterange",
					},
					{
						label: "登录账号",
						type: "input",
						value: "loginID"
					},
					{
						label: "手机号码",
						type: "input",
						value: "cellPhoneNumber "
					},
					{
						label: "电子邮箱",
						type: "input",
						value: "emailAddress "
					},
					{
						label: "IP地址",
						type: "input",
						value: "memberIp"
					}
				],
				listTypeInfo: {
					applicationStatus: [{
							id: "ADD",
							name: "新增人员"
						},
						{
							id: "MODIFY",
							name: "修改人员"
						},
						{
							id: "DELETE",
							name: "删除人员"
						},
					],
				},
				btnStyle: [{
						icon: "el-icon-refresh",
						text: "重置"
					},
					{
						icon: "el-icon-search",
						text: "查询",
						type: "primary"
					},
				],
				pageTotal: 0,
				formData: {
					supplierCompanyName: "",
					startTime: "",
					endTime: "",
					applicationStatus: "",
					loginID: "",
					cellPhoneNumber: "",
					emailAddress: "",
					memberIp: ""
				},
				page: {
					pageNum: 1,
					pageSize: 10,
				},
			};
		},
		created() {
			this.AccessAoThePaging();
		},
		methods: {
			// handleSearch() {
			//    this.formData.pageNum = 10
			//  },
			//重置
			handleClear() {
				this.AccessAoThePaging();
			},
			//查询
			handleQuery(val) {
				console.log(val);
				let Query = {
					email: val.emailAddress,
					logType: val.supplierCompanyName,
					startTime: val.startTime[0],
					mobile: val.cellPhoneNumber,
					operatorMemberName: val.applicationStatus,
					memberName: val.loginID,
					endTime: val.startTime[1],
					pageNum: this.page.pageNum,
					memberIp: val.memberIp,
					pageSize: this.pageSize,
				};
				api.queryMemberPage(Query).then((res) => {
					if (res.code == "200") {
						this.tableData = res.data.records;
						this.pageTotal = res.data.total;
					}
				});
			},
			// //
			// statusFormatter(row){
			//     let name =''
			//     this.listTypeInfo.applicationStatus.forEach(item=>{
			//         if(item.id==row.logType){
			//             console.log(item.id)
			//             name=item.name
			//         }
			//     })
			//     return name
			// },
			handleButton(val) {
				console.log(val);
			},
			handleSortChange() {},
			handleSelectionChange() {},
			//分页导航
			handlePageChange(val) {
				this.page.pageNum = val;
				this.AccessAoThePaging();
			},
			handleSizeChange(pageSize) {
				console.log(pageSize);
				this.page.pageSize = pageSize;
				this.AccessAoThePaging();
			},
			async AccessAoThePaging() {
				let res = await api.queryMemberPage(this.page);
				console.log(res);
				if (res.code == "200") {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				}
			},
		},
	};
</script>

<style scoped lang="scss">
	.time {
		::v-deep .el-input {
			width: 80px;
		}
	}
</style>
